import axios from 'axios';
import toast from 'react-hot-toast';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('evapp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('evapp_token');
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    if (err.code === 'ECONNABORTED') toast.error('Request timed out — check your connection');
    return Promise.reject(err);
  }
);

export default api;
